import React from 'react';

import { observer } from 'mobx-react';
import { Control } from 'react-hook-form';

import { YesNoBtnRow, LbRadioGroup } from '@infoods/lifebase-ui';
import classes from './ScoreForm.module.scss';
import { getDefaultValue } from './ScoreForm.settings';
import { foodScoreStore } from '../../../../stores/foodScoreStore';
import { transformToOptions } from '../../../../../shared/utils/arrayUtils';
import {
  FoodScoreResult,
  FoodScoreTypeName,
} from '../../../../interfaces/FoodScorePageResponse';

export type ScoreFormData = Record<FoodScoreTypeName, number | null>;

type ScoreFormProps = {
  foodScoreResultList: FoodScoreResult[];
  cancelHandler: () => void;
  control: Control<ScoreFormData>;
  onSubmit: React.FormEventHandler<HTMLFormElement>;
};

const ScoreForm = observer(
  ({ foodScoreResultList, cancelHandler, control, onSubmit }: ScoreFormProps) => {
    const { foodScoreTypes } = foodScoreStore;

    const radioForm = foodScoreTypes.map((type) => {
      const options = transformToOptions({
        list: type.settings,
        labelKey: 'foodScoreLabel',
        valueKey: 'foodScoreValue',
      });

      const defaultValue = getDefaultValue(foodScoreResultList, type.foodScoreType);

      return (
        <LbRadioGroup
          key={type.foodScoreType}
          control={control}
          name={type.foodScoreType}
          label={type.typeLabel}
          options={options}
          rules={{ required: 'Select score is required' }}
          defaultValue={defaultValue}
        />
      );
    });

    return (
      <form onSubmit={onSubmit}>
        <YesNoBtnRow
          yesText="Save"
          noText="Cancel"
          className={classes.btnRow}
          noHandler={cancelHandler}
        />
        <div className={classes.descriptionRow}>
          <h4>Description</h4>
          <p>Empty</p>
        </div>
        <div className={classes.formBox}>{radioForm}</div>
      </form>
    );
  },
);

export { ScoreForm };
